import { useNavigate } from 'react-router-dom'
import { BookOpen } from 'lucide-react'
import PYQFilterForm from '../components/PYQFilterForm'
import type { PYQFilterState } from '../types'

export default function PYQFormPage() {
  const navigate = useNavigate()

  const handleSubmit = (filters: PYQFilterState) => {
    // Navigate to browser page with filter params
    const params = new URLSearchParams({
      yearStart: filters.yearStart.toString(),
      yearEnd: filters.yearEnd.toString(),
      subject: filters.subject,
      unitCode: filters.unitCode,
    })

    navigate(`/question-bank/browse?${params.toString()}`)
  }

  return (
    <div className="min-h-full bg-gray-50 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
            <BookOpen className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">
            Previous Year Questions
          </h1>
          <p className="mt-2 text-gray-600">
            Practice questions from past NEET exams
          </p>
        </div>

        {/* Filter Form Card */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Select Questions
          </h2>
          <PYQFilterForm onSubmit={handleSubmit} />
        </div>

        {/* Info Section */}
        <div className="mt-6 bg-blue-50 rounded-lg p-4">
          <h3 className="text-sm font-medium text-blue-800 mb-2">
            How to use
          </h3>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>1. Select the year range for questions</li>
            <li>2. Choose a subject (Physics, Chemistry, or Biology)</li>
            <li>3. Pick a specific unit to focus on</li>
            <li>4. Click "Browse Questions" to start practicing</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
